<div>
  <mat-form-field id="wf-frequency" class="dropdown" *ngIf="!chart" [style.height]="customHight"
    [style.--dropdown-width]="customWidth">
    <!-- lable  -->
    <mat-label>{{title}}</mat-label>

    <!-- dropdown container -->
    <mat-select [value]="selectedOption" id="selectId" (selectionChange)="emitSelectEvent($event)">
      <!-- dropdown options -->
      <mat-option class="option" *ngFor="let option of options" [value]="option">
        {{option.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field id="wf-frequency" *ngIf="chart == 'wfExecute' || chart=='wfTitle'" class="dropdown"
    [style.height]="customHight" [style.--dropdown-width]="customWidth">
    <!-- lable  -->
    <mat-label>{{title}}</mat-label>

    <!-- dropdown container -->
    <mat-select [value]="selectedOption" #select id="selectId" (selectionChange)="emitSelectEvent($event)">
      <!-- dropdown options -->
      <mat-option class="option" *ngFor="let option of options" [value]="option">
        {{option.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- dropdown container -->
  <mat-select class="durationDropDown" [style]="style" *ngIf="chart == 'duration'" [value]="selectedOption" #select
    id="selectId" (selectionChange)="emitSelectEvent($event)">
    <!-- dropdown options -->
    <mat-option class="option" *ngFor="let option of options" [value]="option">
      {{option.name}}
    </mat-option>
  </mat-select>

</div>